// extracted by mini-css-extract-plugin
export var backgroundImage = "Hero-module--backgroundImage--P+qL3";
export var date = "Hero-module--date--iF-my";
export var section = "Hero-module--section--g7N3z";
export var shareAndDate = "Hero-module--shareAndDate--6wpQU";
export var timeToRead = "Hero-module--timeToRead--vytti";
export var wrapper = "Hero-module--wrapper--Hr6i7";